import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-129b42e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = {
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}",
  class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
}
const _hoisted_3 = { class: "d-flex align-items-center texxt-dark fw-bolder my-1 fs-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1))
const _hoisted_5 = {
  key: 0,
  style: {"font-weight":"500","font-size":"16px"}
}
const _hoisted_6 = {
  key: 1,
  class: "h-20px border-gray-200 border-start mx-4"
}
const _hoisted_7 = {
  key: 2,
  class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
}
const _hoisted_8 = { class: "breadcrumb-item pe-3" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1))
const _hoisted_11 = { class: "breadcrumb-item text-muted" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1))
const _hoisted_13 = { class: "breadcrumb-item pe-3 text-dark" }
const _hoisted_14 = { class: "d-flex align-items-center py-1" }
const _hoisted_15 = {
  key: 0,
  style: {"margin-right":"50px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "media/icons/magnify01.png" })
], -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Browse report ")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Withdraw", -1))
const _hoisted_22 = {
  key: 4,
  class: "button__item",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_topup_credit"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Top up", -1))
const _hoisted_24 = {
  key: 5,
  class: "button__item",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_topup_bank"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Bank", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_TopupFormModal = _resolveComponent("TopupFormModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        id: "kt_toolbar_container",
        class: _normalizeClass([{
        'container-fluid': _ctx.toolbarWidthFluid,
        'container-xxl': !_ctx.toolbarWidthFluid,
      }, "d-flex flex-stack"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _hoisted_4,
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.toolbarContent), { isBrowseReport: _ctx.isBrowseReport }, null, 8, ["isBrowseReport"])),
          (_ctx.route.name == 'dashboard')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Overview "))
            : _createCommentVNode("", true),
          (_ctx.breadcrumbs)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.breadcrumbs)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/dashboard",
                    class: "text-muted text-hover-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("li", _hoisted_11, _toDisplayString(item), 1),
                    _hoisted_12
                  ], 64))
                }), 128)),
                _createElementVNode("li", _hoisted_13, _toDisplayString(_ctx.title), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (
            _ctx.isLoading == true &&
            (_ctx.route.name == 'orderReport' ||
              _ctx.route.name == 'promotionReport' ||
              _ctx.route.name == 'riderReport')
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
            : (
            _ctx.isBrowseReport == false &&
            (_ctx.route.name == 'orderReport' ||
              _ctx.route.name == 'promotionReport' ||
              _ctx.route.name == 'riderReport')
          )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn btn__primary btn-sm d-flex algin-center",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isBrowseReport = true))
                }, _hoisted_20))
              : (
            _ctx.route.name == 'orderReport' ||
            _ctx.route.name == 'promotionReport' ||
            _ctx.route.name == 'riderReport'
          )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "btn btn__info btn-sm d-flex algin-center",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getReport()))
                  }, " Show result "))
                : _createCommentVNode("", true),
          (_ctx.route.name == 'walletTransactionList')
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                style: {"margin-right":"15px"},
                class: "button__item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.withdraw()))
              }, [
                _createVNode(_component_inline_svg, {
                  src: "media/icons/withdrawl dollar.svg",
                  width: "18px"
                }),
                _hoisted_21
              ]))
            : _createCommentVNode("", true),
          (_ctx.route.name == 'walletTransactionList')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_inline_svg, {
                  src: "media/icons/add-plus.svg",
                  width: "18px"
                }),
                _hoisted_23
              ]))
            : _createCommentVNode("", true),
          (_ctx.route.name == 'bank_informationList')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_inline_svg, {
                  src: "media/icons/add-plus.svg",
                  width: "18px"
                }),
                _hoisted_25
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _createVNode(_component_TopupFormModal)
  ], 64))
}